module.exports = __webpack_public_path__ + "static/media/welded150x150.6119668c.PNG";